import axios from 'axios'
import { useSetting } from '@/composables/use-setting'

const innerUploadFile = async (file, uploadUrl) => {
  const { getClientInfo } = useSetting()
  const clientInfo = getClientInfo()

  const userToken = clientInfo.userToken
  const formData = new FormData()
  // formData.append('file', file)
  formData.append('file', file.blob, `${file.name}.${file.extension}` || `file.${file.extension}`)
  formData.append('accessType', 'vog-customer')
  formData.append('accessToken', userToken)
  try {
    const response = await axios.post(uploadUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        clientinfo: userToken
      }
    })
    const responseCorrect = typeof response.data === 'object'
    if (!responseCorrect || response.data.rtn_code !== '0000') {
      throw new Error(responseCorrect ? response.data.rtn_msg : 'network error')
    }
    return response.data
  } catch (error) {
    console.error('上传文件时出错:', error)
    throw error
  }
}

export const uploadFile = async (file, uploadUrl, retryCount = 1) => {
  try {
    return await innerUploadFile(file, uploadUrl)
  } catch (err) {
    if (retryCount >= 3) {
      throw err
    } else {
      await uploadFile(file, uploadUrl, retryCount + 1)
    }
  }
}
